function gtag() {
  window.dataLayer.push(arguments);
}
function getCookie(n) {
  const e = n + '=',
    o = document.cookie.split(';');
  for (let n = 0; n < o.length; n++) {
    let t = o[n];
    for (; ' ' === t.charAt(0); ) t = t.substring(1, t.length);
    if (0 === t.indexOf(e)) return JSON.parse(decodeURIComponent(t.substring(e.length, t.length)));
  }
  return {};
}
(window.dataLayer = window.dataLayer || []),
  (window.AVADA_COOKIES_BAR = window.AVADA_COOKIES_BAR || {}),
  (window.AVADA_COOKIE_CONSENT = getCookie('avada_cookie_consent'));
